export const userTypes = {
  ADD_USER: "ADD_USER",
  GET_USER: "GET_USER",
  GET_USER_BY_ID: "GET_USER_BY_ID",
  DELETE_USER: "DELETE_USER",
  SET_USER: "SET_USER",
  SET_USER_BY_ID: "SET_USER_BY_ID",
  SET_DELETE_USER: "SET_DELETE_USER",
  GET_USER_BY_ROLE: "GET_USER_BY_ROLE",
  SET_USER_BY_ROLE: "SET_USER_BY_ROLE",
  EDIT_USER: "EDIT_USER",
  SIGN_UP: "SIGN_UP",
  LOGOUT_EDUCATOR: "LOGOUT_EDUCATOR",
  GET_USER_RATINGS_BY_ID: "GET_USER_RATINGS_BY_ID",
  SET_USER_RATINGS_BY_ID: "SET_USER_RATINGS_BY_ID",
  GET_USER_POINTS: "GET_USER_POINTS",
  SET_USER_POINTS: "SET_USER_POINTS",
  GET_USER_DETAILS_STATISTICS: "GET_USER_DETAILS_STATISTICS",
  SET_USER_DETAILS_STATISTICS: "SET_USER_DETAILS_STATISTICS",
};

export const addUser = (payload: any) => ({
  type: userTypes.ADD_USER,
  payload,
});

export const getUser = () => ({
  type: userTypes.GET_USER,
});

export const setUser = (payload: any) => ({
  type: userTypes.SET_USER,
  payload,
});

export const getUserById = (id: any) => ({
  type: userTypes.GET_USER_BY_ID,
  payload: id,
});

export const setUserById = (payload: any) => ({
  type: userTypes.SET_USER_BY_ID,
  payload,
});

export const deleteUser = (payload: any) => ({
  type: userTypes.DELETE_USER,
  payload,
});

export const setDeleteUser = (id: any) => ({
  type: userTypes.SET_DELETE_USER,
  id,
});

export const editUser = (payload: any) => ({
  type: userTypes.EDIT_USER,
  payload,
});

export const getUserByRole = (payload: any) => ({
  type: userTypes.GET_USER_BY_ROLE,
  payload,
});

export const setUserByRole = (payload: any) => ({
  type: userTypes.SET_USER_BY_ROLE,
  payload,
});

export const signUp = (payload: any) => ({
  type: userTypes.SIGN_UP,
  payload,
});

export const logout = () => ({
  type: userTypes.LOGOUT_EDUCATOR,
});

export const getUserRatingsById = (id: any) => ({
  type: userTypes.GET_USER_RATINGS_BY_ID,
  payload: id,
});

export const setUserRatingsById = (payload: any) => ({
  type: userTypes.SET_USER_RATINGS_BY_ID,
  payload,
});

export const getUserPoints = () => ({
  type: userTypes.GET_USER_POINTS,
});

export const setUserPoints = (payload: any) => ({
  type: userTypes.SET_USER_POINTS,
  payload,
});

export const getUserDetailsStatistics = (payload: any) => ({
  type: userTypes.GET_USER_DETAILS_STATISTICS,
  payload,
});

export const setUserDetailsStatistics = (payload: any) => ({
  type: userTypes.SET_USER_DETAILS_STATISTICS,
  payload,
});
